import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { phraseService } from '../services/phraseService';
import { TopBar } from '../components/common/TopBar';
import { Button } from '../components/common/Button';
import { LoginButton } from '../components/common/LoginButton';
import './Study.css';

const StudyDialogue = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [phrases, setPhrases] = useState([]);
  const [index, setIndex] = useState(0);
  const [step, setStep] = useState(-1); // -1 = before start
  const [myRole, setMyRole] = useState(1); // 1 or 2
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      return;
    }
    phraseService.getUserPhrases(currentUser.uid).then((data) => {
      // Only show phrases that have parts defined
      setPhrases(data.filter((p) => p.parts && p.parts.length > 0));
      setLoading(false);
    });
  }, [currentUser]);

  if (!currentUser) {
    return (
      <div className="study-page">
        <TopBar title="Dialoghi Speaker" onBack={() => navigate('/study')} />
        <div className="study-body study-empty">
          <span className="study-empty__icon">🔐</span>
          <p>Devi effettuare il login per usare i dialoghi.</p>
          <LoginButton className="study-next-btn">Accedi</LoginButton>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="study-page">
        <TopBar title="Dialoghi Speaker" onBack={() => navigate('/study')} />
        <div className="study-body">
          <p style={{ color: 'var(--color-text-muted)' }}>Caricamento…</p>
        </div>
      </div>
    );
  }

  if (phrases.length === 0) {
    return (
      <div className="study-page">
        <TopBar title="Dialoghi Speaker" onBack={() => navigate('/study')} />
        <div className="study-body study-empty">
          <span className="study-empty__icon">📭</span>
          <p>Nessuna frase con dialogo salvata.</p>
          <p style={{ color: 'var(--color-text-dim)', fontSize: '0.85rem' }}>
            In "Gestisci Frasi" aggiungi la suddivisione speaker.
          </p>
          <Button onClick={() => navigate('/phrases')}>Gestisci Frasi</Button>
        </div>
      </div>
    );
  }

  const current = phrases[index];
  const parts = current.parts || [];

  const handleNext = () => {
    setStep(-1);
    const nxt = index + 1;
    if (nxt >= phrases.length) {
      setIndex(0);
    } else {
      setIndex(nxt);
    }
  };

  return (
    <div className="study-page">
      <TopBar
        title="Dialoghi Speaker"
        onBack={() => navigate('/study')}
        actions={
          <span className="study-counter">
            {index + 1}/{phrases.length}
          </span>
        }
      />

      <div className="study-body">
        {/* Role selector */}
        <div className="dialogue-role-selector">
          <button
            className={`dialogue-role-btn ${myRole === 1 ? 'dialogue-role-btn--active' : ''}`}
            onClick={() => {
              setMyRole(1);
              setStep(-1);
            }}
            id="role-speaker1"
          >
            🗣️ Speaker 1
          </button>
          <button
            className={`dialogue-role-btn ${myRole === 2 ? 'dialogue-role-btn--active' : ''}`}
            onClick={() => {
              setMyRole(2);
              setStep(-1);
            }}
            id="role-speaker2"
          >
            🎙️ Speaker 2
          </button>
        </div>

        <p className="dialogue-word">{current.word}</p>

        {/* Dialogue bubbles */}
        <div className="dialogue-bubbles">
          {parts.map((part, i) => {
            const isLeft = part.speaker === 1;
            const isMine = part.speaker === myRole;
            const revealed = i <= step;
            return (
              // eslint-disable-next-line react/no-array-index-key
              <div
                key={i}
                className={`bubble ${isLeft ? 'left' : 'right'} ${!revealed ? 'hidden' : ''} ${isMine && revealed ? 'mine' : ''}`}
                onClick={() => revealed && setStep(Math.max(step, i + 1))}
              >
                {revealed ? isMine ? <strong>{part.text}</strong> : part.text : '•••'}
              </div>
            );
          })}
        </div>

        {step < parts.length - 1 && (
          <button
            className="dialogue-next-btn"
            onClick={() => setStep((s) => s + 1)}
            id="btn-dialogue-reveal"
          >
            {step === -1 ? 'Inizia →' : 'Mostra prossimo →'}
          </button>
        )}

        {step >= parts.length - 1 && (
          <button className="dialogue-next-btn" onClick={handleNext} id="btn-dialogue-next">
            Prossima parola →
          </button>
        )}
      </div>
    </div>
  );
};

export default StudyDialogue;
